<template>

  <div>
    <Head title="Prüfungssimulation" />
    <h1 class="h1"></h1>

    <div class="exam">

      <div class="exam--runnning">

              <question-index :questions="questions.length" :current="index + 1" />

              <questions v-if="index != null"
                         :type="'mistakes'"
                         :questions="questions"
                         :index="index"
                         :is-first-question="isFirstQuestion"
                         @indexChanged="updateIndex"
                         @selfcheck="startSelfcontrol"
                         @finished="questionsFinished"
              ></questions>

              <div v-if="results" class="">
                  <practice-results :questions="questions"></practice-results>
              </div>
      </div>
    </div>

  </div>


</template>

<script>
import {Head} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import PracticeResults from '../../Shared/Mistakes/PracticeResults'

export default {

  components: {
    Head,
    PracticeResults,
  },

  layout: Layout,

  props: {
    mistakes: Array,
  },

  data() {
    return {
      index: 0,
      currentStep: 'questions',
      isFirstQuestion: true,
      showSelfcontrol: false,
      hasResults: false,
      results: null,
      startIndex: 0,
      /**
       * Free Control Data is data that has to be controlled by the user
       * it only comes back if the test has some free text questions
       */
      freeControlData: [],
    }
  },

  computed: {
    questions: function() {
      let questions = []
      this.mistakes.map( mistake => {
        // add property
        mistake.question.mistake_id = mistake.id
        mistake.question.isCorrect = null
        mistake.question.answers = []
        questions.push( mistake.question )
      })
      console.log( questions )
      return questions
    },
  },

  methods: {
    questionsFinished(results) {
      this.results = results
    },

    updateIndex(value) {
      this.index = value
    },

    startSelfcontrol( response ) {
      if(response && response.freetext_data ) {
        this.freeControlData = response.freetext_data
      }
      this.showSelfcontrol = true
    },
  },
}
</script>

<style scoped>

</style>